import { ENV } from "../utils";

// Normas de referencia por plantilla + país, propias del módulo Checklist
// (no depende de Requisitos Legales, ver server/models/checklistNormReference.js).
export class ChecklistNormReference {
  baseApi = ENV.BASE_API;

  async getNormReferences(accessToken, params = {}) {
    const qs = new URLSearchParams();
    if (params.template) qs.set("template", params.template);
    if (params.country)  qs.set("country",  params.country);
    const res = await fetch(`${this.baseApi}/checklist-norm-references?${qs}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const data = await res.json();
    if (res.status !== 200) throw data;
    return data;
  }

  async createNormReference(accessToken, body) {
    const res = await fetch(`${this.baseApi}/add-checklist-norm-reference`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(body),
    });
    const data = await res.json();
    if (res.status !== 200) throw data;
    return data;
  }

  async updateNormReference(accessToken, id, body) {
    const res = await fetch(`${this.baseApi}/update-checklist-norm-reference/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(body),
    });
    const data = await res.json();
    if (res.status !== 200) throw data;
    return data;
  }

  async deleteNormReference(accessToken, id) {
    const res = await fetch(`${this.baseApi}/delete-checklist-norm-reference/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const data = await res.json();
    if (res.status !== 200) throw data;
    return data;
  }
}
